import React, { useState, useEffect } from 'react';
import { Table, Button, Select } from '@ipc/ipc-components';
import 'react-table-hoc-fixed-columns/lib/styles.css';

import { decorateColumns } from '../../utils/table';
import { useFormOptions } from '../../hooks';
import { TopButtonsWrapper, AppContentInner, AppContentTitle } from '../../styles';
import SecureComponent from '../../components/custom/SecureComponent';
import {
  ROLE_CARRIER, ROLE_OPERATOR, ROLE_ADMIN, hasAccess,
} from '../../utils/access';

import { usePerformance } from './hooks';
import { getHeaderTitle } from './helpers';
import { ADMIN_OPTIONS, CARRIER, POSTAL_OPERATOR } from './constants';
import Row from './Row';
import { ButtonWrapper, ToggleButtonWrapper } from './styles';
import AlaTableView from '../../components/custom/AlaTableView';

export default function Performance() {
  const [options, optionsLoaded] = useFormOptions(['dropdown_carrier', 'postal_operator']);
  const [type, updateType] = useState('separate');
  const [values, updateValues] = useState({});
  const [data, loading] = usePerformance(type, values);
  const separateView = type === 'separate';

  useEffect(() => {
    if (optionsLoaded) {
      updateValues({
        operator: options.operator[0],
        carrier: options.carrier[0],
      });
    }
  }, [optionsLoaded]);

  const column = index => ({
    Header: getHeaderTitle(index, type),
    Cell: Row(index),
    accessor: `alaLevelsCount[${index}]`,
  });

  let party = hasAccess([ROLE_CARRIER]) ? POSTAL_OPERATOR : CARRIER;
  if (hasAccess([ROLE_ADMIN]) && values.partyType) {
    if (values.partyType.value === ROLE_OPERATOR) {
      party = CARRIER;
    } else if (values.partyType.value === ROLE_CARRIER) {
      party = POSTAL_OPERATOR;
    }
  }

  const tableColumns = decorateColumns([
    party,
    { Header: 'Average ALA', accessor: 'average' },
    column(1), column(2), column(3), column(4), column(5), column(6), column(7), column(8), column(9), column(0),
  ], []);

  const toggleView = () => {
    if (separateView) {
      updateType('cumulative');
    } else {
      updateType('separate');
    }
  };

  const selectChangeHandler = (value, { name }) => {
    updateValues({ ...values, [name]: value });
  };

  const sortByLabel = (a, b) => ((a.label > b.label) ? 1 : -1);

  return (
    <AppContentInner>
      <AppContentTitle>
        {separateView ? 'Separate ' : 'Cumulative '}
        ALA Performance View
      </AppContentTitle>
      <SecureComponent roles={[ROLE_CARRIER, ROLE_OPERATOR]}>
        <ButtonWrapper>
          <Button onClick={toggleView} data-testid="toggle-button">
            {!separateView ? 'Separate ' : 'Cumulative '}
            ALA Performance View
          </Button>
          <AlaTableView />
        </ButtonWrapper>
      </SecureComponent>
      <SecureComponent roles={[ROLE_ADMIN]}>
        <TopButtonsWrapper>
          <Select options={ADMIN_OPTIONS} value={values.partyType} className="Input SingleSelect" name="partyType" onChange={selectChangeHandler} />
          {values.partyType && (values.partyType.value === ROLE_CARRIER ? (
            <Select options={options.carrier.sort(sortByLabel)} value={values.carrier} className="Input SingleSelect" name="carrier" onChange={selectChangeHandler} />
          ) : (
            <Select options={options.operator.sort(sortByLabel)} value={values.operator} className="Input SingleSelect" name="operator" onChange={selectChangeHandler} />
          ))}

          <ToggleButtonWrapper>
            <Button onClick={toggleView} data-testid="toggle-button">
              {!separateView ? 'Separate ' : 'Cumulative '}
              ALA Performance View
            </Button>
            <AlaTableView />
          </ToggleButtonWrapper>
        </TopButtonsWrapper>
      </SecureComponent>
      <Table
        columns={tableColumns}
        data={data}
        loading={loading}
        minRows={0}
      />
    </AppContentInner>
  );
}
